import React from "react";
import PropTypes from "prop-types";
import styles from "components/documents/document-filters.scss";
import { normalizeNumber } from "utils/string-helpers";

export const TotalRange = ({
  onAddTotalFilter,
  onUpdateTotalFilter,
  totalMax,
  totalMin
}) => (
  <div>
    <div className={ styles["start-container"] }>
      <input
        className={ styles.total }
        defaultValue={ totalMin }
        onBlur={ (e) => onAddTotalFilter("min", normalizeNumber(e.target.value)) }
        onChange={ (e) => onUpdateTotalFilter("min", normalizeNumber(e.target.value)) }
        placeholder="Minimum total"
        type="text"
      />
    </div>
    <div className={ styles["end-container"] }>
      <input
        className={ styles.total }
        defaultValue={ totalMax }
        onBlur={ (e) => onAddTotalFilter("max", normalizeNumber(e.target.value)) }
        onChange={ (e) => onUpdateTotalFilter("max", normalizeNumber(e.target.value)) }
        placeholder="Maximum total"
        type="text"
      />
    </div>
  </div>
);

TotalRange.defaultProps = {
  totalMax: "",
  totalMin: ""
};

TotalRange.propTypes = {
  onAddTotalFilter: PropTypes.func.isRequired,
  onUpdateTotalFilter: PropTypes.func.isRequired,
  totalMax: PropTypes.string,
  totalMin: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/js/components/documents/filters/total-range.jsx